import { useFetch } from '@/hooks/useFetch';  
import type { ErrorResponse } from '@/types/apiTypes';
import type { CreateClientPassportData, CreateClientPassportResponse } from '@/types/clientDetailsApiTypes';
import { useMutation } from '@tanstack/react-query';

export const useCreateClientPassportData = () => {
  const { doFetch: createClientPassportData } = useFetch<CreateClientPassportData, CreateClientPassportResponse>();

  return useMutation<CreateClientPassportResponse, ErrorResponse<unknown>, { clientId: string, data: CreateClientPassportData }>({
    mutationFn: ({ clientId, data }: { clientId: string, data: CreateClientPassportData }) => createClientPassportData(`/api/documents/passport/client/${clientId}`, { method: 'POST', body: data }),
  });
};